export const MODAL_TYPES = {
  ENTER_PIN: 'ENTER_PIN',
  INFO: 'INFO',
  CONFIRM: 'CONFIRM',
  LOGIN: 'LOGIN',
  NOTIFICATION: 'NOTIFICATION',
  PENDING: 'PENDING',
};
